import ChatOnline from "../../components/chatOnline/ChatOnline";
import Conversation from "../../components/conversations/Conversation";
import Message from "../../components/message/Message";
import "../../style.scss";
import "./messenger.scss";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/authContext";
import { makeRequest } from "../../axios";

const Messenger = () => {
  const { currentUser } = useContext(AuthContext);
  const [conversations, setConversations] = useState([])
  const [currentChat, setCurrentChat] = useState(null);
  const [messages, setMessages] = useState([]);

  useEffect(()=>{
    const getConversations = async () => {
      try{
        const res = await makeRequest.get("/conversations/" + currentUser.id);
        setConversations(res.data)
      } catch (err) {
        console.log(err);
      }
    };
    getConversations();
  }, [currentUser.id]);

  //this is the array with all conversations matching

  useEffect(() => {
    const getMessages = async () => {
      try {
        const res = await makeRequest.get("/messages/" + currentChat?._id);        
        setMessages(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    getMessages();
  }, [currentChat]);

    const newData = conversations.map(function(conversation){
      return [conversation.senderId, conversation.receiverId];
    })

    console.log(newData);
    
  return (
    <div className="messenger">
      <div className="chatMenu">
        <div className="chatMenuContainer">
          <input placeholder="Search for Friends" className="chatMenuInput"/>
          {newData.map(m => (
            <Conversation key={m.indexOf()} conversation={m} currentUser={currentUser}/>
          ))}
        </div>
      </div>
      <div className="chatBox">
        <div className="chatBoxContainer">
          <div className="chatBoxTop">
            <Message/>
            <Message own={true}/>
            <Message/>
            <Message own={true}/>
            <Message/>
            <Message own={true}/>
          </div>
          <div className="chatBoxBottom">
            <textarea placeholder="write a message..."></textarea>
            <button>Send</button>
          </div>
        </div>
      </div>
      <div className="chatOnline">
        <div className="chatOnlineContainer">
          <ChatOnline/>
        </div>
      </div>
    </div>
  );
};

export default Messenger;
